var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 16.0001C27.9998 16.2653 27.8945 16.5196 27.7069 16.7072C27.5194 16.8947 27.265 17.0001 26.9998 17.0001H7.41356L14.7073 24.2926C14.8002 24.3855 14.8739 24.4958 14.9242 24.6172C14.9745 24.7386 15.0004 24.8687 15.0004 25.0001C15.0004 25.1315 14.9745 25.2616 14.9242 25.383C14.8739 25.5044 14.8002 25.6147 14.7073 25.7076C14.6144 25.8005 14.5041 25.8742 14.3827 25.9245C14.2613 25.9747 14.1312 26.0006 13.9998 26.0006C13.8684 26.0006 13.7383 25.9747 13.6169 25.9245C13.4955 25.8742 13.3852 25.8005 13.2923 25.7076L4.29231 16.7076C4.19933 16.6147 4.12557 16.5044 4.07525 16.383C4.02493 16.2616 3.99902 16.1315 3.99902 16.0001C3.99902 15.8687 4.02493 15.7385 4.07525 15.6171C4.12557 15.4957 4.19933 15.3854 4.29231 15.2926L13.2923 6.29257C13.4799 6.10493 13.7344 5.99951 13.9998 5.99951C14.2652 5.99951 14.5197 6.10493 14.7073 6.29257C14.895 6.48021 15.0004 6.7347 15.0004 7.00007C15.0004 7.26543 14.895 7.51993 14.7073 7.70757L7.41356 15.0001H26.9998C27.265 15.0001 27.5194 15.1054 27.7069 15.293C27.8945 15.4805 27.9998 15.7349 27.9998 16.0001Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.b1910f61df7477fd7a747218d93fa0d3.svg";
export { ForwardRef as ReactComponent };